import { IComponent } from '@faire/web-api--source/indigofair/data/IComponent';
import { ILayout } from '@faire/web-api--source/indigofair/data/ILayout';

export namespace ILayoutSection {
  /**
   * Return an instance of ILayoutSection with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<ILayoutSection>): ILayoutSection =>
    ({
      components: [],
      ...(partial ?? {}),
    }) as ILayoutSection;
}

/**
 * A section that lays out a list of components as indicated by Layout
 */
export interface ILayoutSection {
  /**
   * the components to be rendered within the section
   */
  components: Array<IComponent>;
  /**
   * the information for how to lay out these components
   */
  layout: ILayout | undefined;
}
